import { COLUMN_FLOOR, COLUMN_LIFTS_COUNT, COLUMN_NAME, COLUMN_SITE } from "../../constants/column-types";
import { FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const BuildingColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        active: true,
        sortByName: "buildingName",
        sortDirection: "asc",
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 1,
        sortByName: "site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: "site.id",
        lookupName: "site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        settingDataName: 'site',
        columnId: COLUMN_SITE,
    },
    {
        heading: "Floors",
        accessor: "floors",
        isNumeric: true,
        id: 2,
        active: true,
        translationKey: "floors",
        columnId: COLUMN_FLOOR,
    },
    {
        heading: "Lifts",
        accessor: "lifts",
        id: 3,
        isNumeric: true,
        active: true,
        translationKey: "lifts",
        columnId: COLUMN_LIFTS_COUNT,
    }
];

export default BuildingColumns;
